const { listPrograms } = require('../../../program/api/read/list-programs')
const isEqual = require('lodash/isEqual')

const validateReportingPeriod = async (state, {existingPrograms = [], newPrograms = []}) => {
  if (isEqual(existingPrograms, newPrograms) || newPrograms.length === 1) return true

  // Intentionally not limiting to current user programs since the edited user
  // might already be in programs the current user is not assigned to.
  // What we are not checking in this function is if an admin is trying to add a
  // user to a program they themselves are not assigned to or if any of the
  // `newPrograms` does not exist.
  const allPrograms = await listPrograms(state, { unfiltered: true })
  const unitReportingPeriod = allPrograms.find(program => program.id === newPrograms[0]).reportingPeriod

  return newPrograms.every(newProgram => {
    const reportingPeriod = allPrograms.find(program => program.id === newProgram).reportingPeriod
    return unitReportingPeriod === reportingPeriod
  })
}

exports.validateReportingPeriod = validateReportingPeriod
